<template>
  <div class="item-wrapper">
    <a :href="item.url">
      <img :src="image" :alt="item.name" v-if="image" />
      <div class="item-info">
        <h5 class="item-name"> {{ item.name }}</h5>
        <p class="item-description" v-html="item.description"></p>
        <time class="item-date"> {{ item.date }}</time>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    item: Object
  },
  data: () => {
    return {
      image: ''
    }
  },
  mounted() {
    this.image = this.item.image ? this.$config.hostname + this.item.image : '';
  }
}
</script>

<style scoped lang="scss">
.item-wrapper {
  width: 100%;
  margin-bottom: 30px;
  background: #FFFFFF;
  border: 2px solid #F5F5F5;
  border-radius: 12px;
  filter: drop-shadow(0px 5px 35px rgba(0, 0, 0, 0.1));

  img {
    width: 100%;
    border-radius: 8px;
  }

  .item-info {
    padding: 32px 16px 20px;
    font-family: 'Gilroy';
    font-style: normal;

    .item-name {
      margin-bottom: 30px;
      font-weight: 700;
      font-size: 18px;
      line-height: 22px;
      color: #333333;
    }

    .item-description {
      margin-bottom: 20px;
      font-weight: 400;
      font-size: 18px;
      line-height: 26px;
      color: #000000;
    }

    .item-date {
      display: block;
      text-align: right;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #828282;
    }
  }
}

@media screen and (max-width: 650px) {
  .item-wrapper {
    margin-bottom: 20px;

    .item-info {
      padding: 32px 16px 10px;

      .item-name {
        margin-bottom: 32px;
        font-size: 14px;
        line-height: 17px;
      }

      .item-description {
        margin-bottom: 10px;
        font-size: 12px;
        line-height: 20px;
      }

      .item-date {
        font-size: 12px;
        line-height: 17px;
      }
    }
  }
}
</style>
